import script from "./CameraCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraCapture.vue?vue&type=script&setup=true&lang=js"

import "./CameraCapture.vue?vue&type=style&index=0&id=775eb324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-775eb324"]])

export default __exports__